

function patchRoot(root) {

  function toValue(object) {
    if (typeof object === "number") {
      return {
        numberValue: object
      }
    }
    if (typeof object === "boolean") {
      return {
        boolValue: object
      }
    }
    if (typeof object === "string") {
      return {
        stringValue: object
      }
    }
    if (object === null) {
      return {
        nullValue: 0
      }
    }
    if (Array.isArray(object)) {
      const values = object.map(e => toValue(e))
      return {
        listValue: { values }
      }
    }
    if (typeof object === "object") {
      const fields = {};
      for (const [key, value] of Object.entries(object)) {
        fields[key] = toValue(value);
      }
      return {
        structValue: { fields },
      }
    }
    return undefined;
  }

  function toJSON(message) {
    if (typeof message.numberValue !== 'undefined') {
      return message.numberValue;
    }
    if (typeof message.boolValue !== 'undefined') {
      return message.boolValue;
    }
    if (typeof message.stringValue !== 'undefined') {
      return message.stringValue;
    }
    if (typeof message.nullValue !== 'undefined') {
      return null;
    }
    if (typeof message.listValue !== 'undefined') {
      return message.listValue.values.map(toJSON);
    }
    if (typeof message.structValue !== 'undefined') {
      return message.structValue;
    }
    if (typeof message.fields !== 'undefined') {
      const json = {};
      for (const [key, value] of Object.entries(message.fields)) {
        json[key] = toJSON(value);
      }
      return json;
    }
    return undefined;
  }

  const Struct = root.google.protobuf.Struct;
  class PlainJsonStruct extends Struct {
    constructor(...args) {
      super(...args);
    }

    static create(...args) {
      return new PlainJsonStruct(...args);
    }

    static fromObject(object) {
      if (typeof object !== "object") {
        throw new Error("Struct must be object")
      }

      try {
        const { structValue } = toValue(object);
        root.google.protobuf.Struct = Struct;
        return super.fromObject(structValue)
      } finally {
        root.google.protobuf.Struct = PlainJsonStruct
      }
    }

    static toObject(message, options) {
      const object = super.toObject(message, options);
      return toJSON(object);
    }
  }

  root.google.protobuf.Struct = PlainJsonStruct;
}

module.exports = patchRoot;